import { withMetadata } from '../metadata'
import { isValidPhoneNumber as _isValidPhoneNumber } from '../../core/index'

export function isValidPhoneNumber() {
	return withMetadata(_isValidPhoneNumber, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/min/exports/isValidPhoneNumber.js
// module id = 624
// module chunks = 0